/**
 * @param {string} value
 */
export function dutchNumberStringToIntl(value) {
    if (typeof (value) !== 'string') {
        throw Error("Given value ".concat(value, " is not a string"));
    }
    // Note that this doesn't work perfect. A dutch number string with thousand separators will return
    // a intl string with multiple decimal dot separators.
    return value.replace(/,/g, '.');
}
